// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const creditTransactionDto = {
    guid: 'guid',
    type: 'type',
    domainGuid: 'domainGuid',
    domainName: 'domainName',
    period: 'period',
    credits: 'credits',
    invoiceNr: 'invoiceNr',
    invoiceGuid: 'invoiceGuid',
    invoiceTotal: 'invoiceTotal',
    relatedTransactionGuid: 'relatedTransactionGuid',
    note: 'note',
    createdOn: 'createdOn',
    createdByName: 'createdByName',
} as const;

export type TCreditTransactionDto = (typeof creditTransactionDto)[keyof typeof creditTransactionDto];

export interface ICreditTransactionDto {
    [creditTransactionDto.guid]: string | null;
    [creditTransactionDto.type]: string | null;
    [creditTransactionDto.domainGuid]: string | null;
    [creditTransactionDto.domainName]: string | null;
    [creditTransactionDto.period]: string | null;
    [creditTransactionDto.credits]: number | null;
    [creditTransactionDto.invoiceNr]: number | null;
    [creditTransactionDto.invoiceGuid]: string | null;
    [creditTransactionDto.invoiceTotal]: number | null;
    [creditTransactionDto.relatedTransactionGuid]: string | null;
    [creditTransactionDto.note]: string | null;
    [creditTransactionDto.createdOn]: string | null;
    [creditTransactionDto.createdByName]: string | null;
}

export class CreditTransactionDto
    implements ICreditTransactionDto
{
    [creditTransactionDto.guid]: string | null = null;
    [creditTransactionDto.type]: string | null = null;
    [creditTransactionDto.domainGuid]: string | null = null;
    [creditTransactionDto.domainName]: string | null = null;
    [creditTransactionDto.period]: string | null = null;
    [creditTransactionDto.credits]: number | null = null;
    [creditTransactionDto.invoiceNr]: number | null = null;
    [creditTransactionDto.invoiceGuid]: string | null = null;
    [creditTransactionDto.invoiceTotal]: number | null = null;
    [creditTransactionDto.relatedTransactionGuid]: string | null = null;
    [creditTransactionDto.note]: string | null = null;
    [creditTransactionDto.createdOn]: string | null = null;
    [creditTransactionDto.createdByName]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door ICreditTransactionData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[creditTransactionDto.guid] = modelData[credittransactionData.guid];
    }

    static create(modelData?: any | null): ICreditTransactionDto | null {
        return modelData ? new CreditTransactionDto(modelData) : null;
    }
}
